import { Box, Skeleton } from "@outschool/backpack";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import { DESKTOP_AVATAR_SIZE, MOBILE_AVATAR_SIZE } from "./utils";

export const TutorCardSkeleton = () => {
  const isMobile = useIsMobile();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <Skeleton
        variant="circular"
        height={isMobile ? MOBILE_AVATAR_SIZE : DESKTOP_AVATAR_SIZE}
        width={isMobile ? MOBILE_AVATAR_SIZE : DESKTOP_AVATAR_SIZE}
      />
      <Skeleton
        variant="text"
        height={24}
        width={isMobile ? MOBILE_AVATAR_SIZE : DESKTOP_AVATAR_SIZE}
      />
    </Box>
  );
};
